import { formatPhoneNumber, PhoneNumberE164, TelecomPhoneLineId } from "@sp-crm/core";
import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import React from "react";
import { SmsTranscript } from "./sms-transcript";

interface SmsTranscriptPanelProps {
    isOpen: boolean;
    onDismiss: () => void;
    phoneLineId: TelecomPhoneLineId;
    phoneNumber: PhoneNumberE164;
    senderName: string;
}

export const SmsTranscriptPanel: React.FC<SmsTranscriptPanelProps> = props => {
    const { isOpen, onDismiss, phoneLineId, phoneNumber, senderName } = props;

    return (
        <Panel
            isOpen={isOpen}
            onDismiss={onDismiss}
            type={PanelType.large}
            headerText={`Conversation with ${formatPhoneNumber(phoneNumber)}`}>
            <SmsTranscript
                phoneLineId={phoneLineId}
                phoneNumber={phoneNumber}
                senderName={senderName}
                onClose={onDismiss}
            />
        </Panel>
    );
};
